import { render } from "./CrudAreas.vue?vue&type=template&id=b4dd5476&scoped=true"
import script from "./CrudAreas.vue?vue&type=script&lang=js"
export * from "./CrudAreas.vue?vue&type=script&lang=js"

import "./CrudAreas.vue?vue&type=style&index=0&id=b4dd5476&lang=css"
import "./CrudAreas.vue?vue&type=style&index=1&id=b4dd5476&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4dd5476"]])

export default __exports__